<template>
    <div v-if="!hasAccepted" class="h-0 relative">
        <div class="fixed z-50 bottom-0 w-full flex justify-between items-center fade-in bg-neutral-light text-white shadow-lg p-4">
            <div class="flex-grow">
                Wir verwenden Cookies, die für den technischen Betrieb der Website notwendig sind. Weitere Informationen finden Sie in unserer <router-link to="/privacy" class="underline">Datenschutzerklärung</router-link>.
            </div>
            <base-button @click="setAccept()" type="button" class="button-min-width" button-class="invert_white">
                Akzeptieren
            </base-button>
        </div>
    </div>

</template>

<script>
import {computed} from "vue";
import {useStore} from "vuex";

export default {
    setup() {
        const store = useStore();
        const hasAccepted = computed(() => store.getters['Cookie/hasAccepted'])


        const setAccept = () => {
            store.dispatch('Cookie/setAccept', 1)
        }

        return {
            hasAccepted,
            setAccept
        }
    }
}
</script>

<style scoped>

</style>
